import { Box, Text } from '@rbilabs/universal-components';

import Link from 'components/link';
import LoyaltyRewardsLogo from 'pages/loyalty/loyalty-rewards-logo';
import { getDesignToken, primitive } from 'styles/constants';
const MAX_WIDTH_FOR_REWARDS_LOGO = '262px';

export const HistorySignUpContainer = Box.withConfig({
  borderRadius: '10px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: primitive.$mayoEggWhite,
  backgroundColor: getDesignToken('background-card'),
  fontSize: 'md',
  color: primitive.$bbqBrown,
  marginBottom: '$2',
});

export const HeaderAndLogoContainer = Box.withConfig({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '$4',
});

export const ButtonContainer = Box.withConfig({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '$4',
  fontSize: 'sm',
  textAlign: 'center',
});

export const HeaderContainer = Box.withConfig({
  marginTop: '$2',
});

export const NormalText = Text.withConfig({
  fontSize: 'md',
  textAlign: 'center',
});

export const StyledRewardsLogo = LoyaltyRewardsLogo.withConfig({
  width: MAX_WIDTH_FOR_REWARDS_LOGO,
  marginTop: '$2',
});

export const StyledLink = Link.withConfig({
  color: getDesignToken('text-link-default'),
  _text: {
    variant: 'headerThree',
    marginTop: '$10',
  },
  textDecoration: 'none',
  marginBottom: '$4',
  marginLeft: '$1',

  _hover: {
    color: getDesignToken('text-link-hover'),
  },
});
